'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _reactTinymceInput = require('react-tinymce-input');

var _reactTinymceInput2 = _interopRequireDefault(_reactTinymceInput);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DescriptionBox = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(DescriptionBox, _Component);

  function DescriptionBox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DescriptionBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DescriptionBox.__proto__ || (0, _getPrototypeOf2.default)(DescriptionBox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focused: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DescriptionBox, [{
    key: 'render',
    value: function render() {
      var focused = this.state.focused;
      var _props = this.props,
          description = _props.description,
          errors = _props.errors,
          required = _props.required;

      var tinymceConfig = {
        menubar: false,
        plugins: 'autoresize link code paste',
        autoresize_max_height: 600,
        statusbar: false,
        paste_preprocess: function paste_preprocess(plugin, args) {
          args.content = args.content.replace(/<(?:[^\/a](?:.|\n)*?>|(?:[^a]|\n)*?>)/gm, '');
        },
        toolbar: 'bold | italic | underline | numlist | bullist | link unlink | copy cut paste | hr | code'
      };

      return _react2.default.createElement(
        'div',
        { className: 'description-box' },
        _react2.default.createElement(
          'div',
          { className: 'line-box' + (focused ? ' active' : '') + (errors.length > 0 ? ' has-error' : '') },
          _react2.default.createElement(
            'div',
            { tabIndex: '-1', id: 'htmleditor-textarea', name: 'description', 'data-placeholder': 'Entrez une description...' },
            _react2.default.createElement(_reactTinymceInput2.default, { value: description, onChange: this.props.onChange, tinymceConfig: tinymceConfig })
          ),
          required && (!description || description && !description.length) && _react2.default.createElement(
            'span',
            { className: 'label label-danger label-required required-description pull-right' },
            'Requis'
          )
        )
      );
    }
  }]);
  return DescriptionBox;
}(_react.Component), _class.propTypes = {
  description: _propTypes2.default.string,
  errors: _propTypes2.default.array,
  onChange: _propTypes2.default.func,
  polyglot: _propTypes2.default.object.isRequired,
  popoverContainer: _propTypes2.default.any,
  required: _propTypes2.default.bool
}, _class.defaultProps = {
  required: true,
  errors: []
}, _temp2);
exports.default = DescriptionBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/DescriptionBox.js
// module id = 2210
// module chunks = 0